$(document).ready(function() {
  // Select the last two items within .check-projects
  var lastTwoItems = $('.check-projects').children().slice(-2);
  
  // Check if both items have the classes .col-lg-6 and .col-xxl-4
  if (lastTwoItems.first().hasClass('col-xxl-4') && lastTwoItems.last().hasClass('col-xxl-4')) {
    $('.check-projects .col-xxl-4:last-child').removeClass('col-xxl-4').removeClass('col-lg-6').addClass('col-xxl-8 check-projects-grid').contents().wrapAll('<div class="row"></div>');
    $('.check-projects-grid .row > div').addClass('col-lg-6');
  }
});
